import React from 'react';
import { AdvertisingButton } from 'src/components/AdvertisingButton';
import { WebsiteButton } from 'src/components/WebsiteButton';
import { IItem } from 'src/interfaces/organizations';

import { Space } from '@sravni/react-design-system';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

interface IWrapperAdvertisingButtonProps extends Pick<IItem, 'ad'> {
  type: PAGE_TYPE;
  organization: IItem;
}

const VALID_PAGE_TYPES = [PAGE_TYPE.Zaimy, PAGE_TYPE.Bukmeker];

export const WrapperAdvertisingButton: React.FC<IWrapperAdvertisingButtonProps> = ({ type, organization, ad }) =>
  VALID_PAGE_TYPES.includes(type) && (
    <Space className={'h-mt-24'}>
      {type === PAGE_TYPE.Zaimy && ad && <AdvertisingButton item={organization} btnText={'Взять займ'} />}
      {type === PAGE_TYPE.Bukmeker &&
        (ad ? (
          <AdvertisingButton item={organization} btnText={'Перейти на сайт'} />
        ) : (
          <WebsiteButton link={organization.contacts.website} />
        ))}
    </Space>
  );
